import OtpInput from 'react-otp-input';
import classnames from 'classnames';

interface Props {
  value: string;
  onChange: (value: string) => void;
  numInputs?: number;
  shouldAutoFocus?: boolean;
  className?: string;
}

// Shared OTP digit-box input used by both the web OtpFlow and the mobile login OtpForm.
// react-otp-input owns each box's value internally, so it stays stable across parent
// re-renders (e.g. the resend countdown ticking every second) — unlike a controlled
// IonInput, which was being reset to its empty bound value mid-typing.
export default function OtpCodeInput(props: Props) {
  const { value, onChange, numInputs = 4, shouldAutoFocus = true, className } = props;

  return (
    <div className={classnames('flex justify-center', className)} data-test="otp-code-input">
      <OtpInput
        value={value}
        onChange={onChange}
        numInputs={numInputs}
        shouldAutoFocus={shouldAutoFocus}
        renderInput={(inputProps, index) => (
          <input
            {...inputProps}
            inputMode="numeric"
            data-test={`otp-code-digit-${index}`}
            className={classnames(
              otpInputBase,
              inputProps.value
                ? 'border-brand-primary text-brand-primary'
                : 'border-brand-border text-brand-text-primary focus:border-brand-primary/50 focus:ring-2 focus:ring-brand-primary/20',
            )}
          />
        )}
      />
    </div>
  );
}

// Styles
const otpInputBase =
  '!w-14 !h-14 text-center text-xl font-bold rounded-xl border-2 bg-brand-card transition-all focus:outline-none mx-xs aspect-square';
